import { render } from "./KanbanBoard.vue?vue&type=template&id=9b55bac0&scoped=true"
import script from "./KanbanBoard.vue?vue&type=script&lang=js"
export * from "./KanbanBoard.vue?vue&type=script&lang=js"

import "./KanbanBoard.vue?vue&type=style&index=0&id=9b55bac0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b55bac0"]])

export default __exports__